import { Injectable } from '@angular/core';
import { EStatusBadgeExtraCategory, EWorkflow, TStatusBadgeCategory } from '../../../pages/items/items.interface';
import { EItemTimingStatus, IItemTimingWorkInstruction } from '../item-timing/item-timing.interface';
import { EWorkInstructionStatus, IWorkInstructionStatus } from './work-instruction-status.interface';

const STATUS: Record<EItemTimingStatus, EWorkInstructionStatus> = {
  [EItemTimingStatus.completed]: EWorkInstructionStatus.completed,
  [EItemTimingStatus.inProgress]: EWorkInstructionStatus.ongoing,
  [EItemTimingStatus.notStarted]: EWorkInstructionStatus.notStarted,
  [EItemTimingStatus.paused]: EWorkInstructionStatus.paused,
};
const STATUS_CATEGORY: Record<EWorkInstructionStatus, TStatusBadgeCategory> = {
  [EWorkInstructionStatus.completed]: EWorkflow.done,
  [EWorkInstructionStatus.notStarted]: EWorkflow.todo,
  [EWorkInstructionStatus.ongoing]: EWorkflow.inProgress,
  [EWorkInstructionStatus.paused]: EStatusBadgeExtraCategory.paused,
};

/**
 * Presentation view of a work instruction timing. The status, the step counts and the Late flag are decided by
 * GET items/timings/{itemKey}; this only names them the way the badges and labels expect.
 */
@Injectable({ providedIn: 'root' })
export class WorkInstructionStatusService {
  public getWorkInstructionStatus(workInstruction: IItemTimingWorkInstruction): IWorkInstructionStatus {
    const status: EWorkInstructionStatus = STATUS[workInstruction.status];

    return {
      completedStepCount: workInstruction.completedStepCount,
      isLate: workInstruction.isLate,
      percentage: workInstruction.totalStepCount
        ? Math.round((workInstruction.completedStepCount / workInstruction.totalStepCount) * 100)
        : 0,
      status,
      statusCategory: STATUS_CATEGORY[status],
      totalStepCount: workInstruction.totalStepCount,
    };
  }
}
